/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf14.png';

const NetLossStep2 = ({ previousShownErrors }) => (
  <BannerLayout
    section="FEEDBACK"
    subSection="NET LOSS"
    previousShownErrors={previousShownErrors}
    alertText="Your company generated a net loss."
    subTitle="You gotta make a profit!"
    paragraph1={(
      <Fragment>
        It's very common and expected to generate losses in the early years, but investors expect
        companies to make a profit at some point.
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        Uber learned the hard way when they went public, expecting to be valued at $120 billion dollars,
        but their net losses, which were in the billions, concerned investors to the point where Uber lost
        60% of its market value within a few months of their
        IPO. <a href="https://www.thedrive.com/news/27393/uber-officially-files-ipo-in-new-york-stock-exchange-with-valuation-of-up-to-120b" rel="noreferrer" target="_blank">Learn More</a>
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default NetLossStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/net-loss/step2.js